import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MarkReadNotificationService {
  private notificationMarkedSubject: Subject<boolean> = new Subject<boolean>();

  // Observable to notify when a notification is marked
  notificationMarked$: Observable<boolean> =
    this.notificationMarkedSubject.asObservable();

  // Emit the event
  notifyNotificationMarked(isViewAction: boolean = false): void {
    this.notificationMarkedSubject.next(isViewAction);
  }
}
